<template>
  <div class="icon-set" :class="{ 'has-background-primary': inverted }">
    <div class="icon-container">
      <img :src="iconImage1" />
      <p class="subtitle is-5" :class="{ 'has-text-white': inverted }">{{ iconText1 }}</p>
    </div>
    <div class="icon-container">
      <img :src="iconImage2" />
      <p class="subtitle is-5" :class="{ 'has-text-white': inverted }">{{ iconText2 }}</p>
    </div>
    <div class="icon-container">
      <img :src="iconImage3" />
      <p class="subtitle is-5" :class="{ 'has-text-white': inverted }">{{ iconText3 }}</p>
    </div>
    <div class="icon-container">
      <img :src="iconImage4" />
      <p class="subtitle is-5" :class="{ 'has-text-white': inverted }">{{ iconText4 }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconSet',
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
    iconImage1: {
      type: String,
      default: '',
    },
    iconImage2: {
      type: String,
      default: '',
    },
    iconImage3: {
      type: String,
      default: '',
    },
    iconImage4: {
      type: String,
      default: '',
    },
    iconText1: {
      type: String,
      default: '',
    },
    iconText2: {
      type: String,
      default: '',
    },
    iconText3: {
      type: String,
      default: '',
    },
    iconText4: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-set {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10%;
  padding-right: 10%;
  align-items: flex-start;
  justify-content: space-evenly;
  margin-top: 20px;
  margin-bottom: 20px;

  .icon-container {
    text-align: center;
    width: 140px;

    img {
      width: 120px;
    }
  }
}
</style>
